import { Link } from 'react-router-dom';
import Logo from './Logo';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 text-slate-300 border-t border-slate-800">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-9">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-7 items-start">
          
          {/* Brand Col */}
          <div>
            <Link to="/" className="inline-block group">
              <Logo variant="light" size="sm" />
            </Link>
          </div>

          {/* Navigation Links */}
          <div>
            <h4 className="text-white font-semibold text-xs tracking-wider uppercase mb-2.5">
              Navigation
            </h4>
            <ul className="space-y-1.5 text-xs sm:text-sm">
              <li>
                <Link to="/" className="text-slate-400 hover:text-white transition">
                  Forside
                </Link>
              </li>
              <li>
                <Link to="/ydelser" className="text-slate-400 hover:text-white transition font-medium">
                  Ydelser (oversigt)
                </Link>
              </li>
              <li>
                <Link to="/ydelser/klinisk-videoproduktion" className="text-slate-400 hover:text-white transition pl-2 text-xs">
                  ↳ Optage- & fotovejledning
                </Link>
              </li>
              <li>
                <Link to="/ydelser/shortform-content" className="text-slate-400 hover:text-white transition pl-2 text-xs">
                  ↳ Videoredigering & klip
                </Link>
              </li>
              <li>
                <Link to="/ydelser/distribution-og-synlighed" className="text-slate-400 hover:text-white transition pl-2 text-xs">
                  ↳ Meta postkalender & profiler
                </Link>
              </li>
              <li>
                <Link to="/cases" className="text-slate-400 hover:text-white transition">
                  Cases & Resultater
                </Link>
              </li>
              <li>
                <Link to="/om-os" className="text-slate-400 hover:text-white transition">
                  Om os
                </Link>
              </li>
              <li>
                <Link to="/kontakt" className="text-slate-400 hover:text-white transition">
                  Kontakt / Book samtale
                </Link>
              </li>
            </ul>
          </div>

          {/* Target Audience */}
          <div>
            <h4 className="text-white font-semibold text-xs tracking-wider uppercase mb-2.5">
              Sundhedsaktører
            </h4>
            <ul className="space-y-1.5 text-xs sm:text-sm text-slate-400">
              <li>
                <span>Privathospitaler</span>
              </li>
              <li>
                <span>Kiropraktiske klinikker</span>
              </li>
              <li>
                <span>Speciallægeklinikker</span>
              </li>
              <li>
                <span>Fysioterapi & behandlerhuse</span>
              </li>
              <li>
                <span>Tandlæger & øvrige faggrupper</span>
              </li>
            </ul>
          </div>

          {/* Contact Details */}
          <div>
            <h4 className="text-white font-semibold text-xs tracking-wider uppercase mb-2.5">
              Kontakt
            </h4>
            <div className="space-y-1.5 text-xs sm:text-sm text-slate-400">
              <div>
                <a 
                  href="tel:+4561489206" 
                  className="text-sky-400 hover:underline no-wrap-contact inline-block"
                >
                  +45 61 48 92 06
                </a>
              </div>
              <div>
                <a 
                  href="mailto:health4media@gmail.com" 
                  className="text-sky-400 hover:underline no-wrap-contact inline-block"
                >
                  health4media@gmail.com
                </a>
              </div>
              <div className="text-slate-400">
                <p>CVR: 46697553</p>
              </div>
            </div>
          </div>

        </div>

        {/* Bottom bar */}
        <div className="border-t border-slate-800 mt-7 pt-4 flex flex-col sm:flex-row items-center justify-between text-xs text-slate-500 gap-2">
          <p>© {currentYear} Health4media · CVR: 46697553. Alle rettigheder forbeholdes.</p>
          <p>
            Online rådgivning, videoredigering, SoMe-opsætning og Meta postkalender til sundhedssektoren.
          </p>
        </div>
      </div>
    </footer>
  );
}
